/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Access_TitleInputs */

const en_customer_access_title = /** @type {(inputs: Customer_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer Access`)
};

const es_customer_access_title = /** @type {(inputs: Customer_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso de cliente`)
};

/**
* | output |
* | --- |
* | "Customer Access" |
*
* @param {Customer_Access_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const customer_access_title = /** @type {((inputs?: Customer_Access_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Access_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_customer_access_title(inputs)
	return es_customer_access_title(inputs)
});